export default __webpack_public_path__ + "media/images/react_icons/casatb/casatb_logo_inverted-fdfbf7ba614eb25d0bc21fd14a145678.svg";